import { AutosBadgeCarFax } from '@/components/srp/listing-card/autos-badges/AutosBadgeCarFax'
import { AutosBadgeCertifiedPreOwner } from '@/components/srp/listing-card/autos-badges/AutosBadgeCertifiedPreOwner'
import { AutosBadgeContactless } from '@/components/srp/listing-card/autos-badges/AutosBadgeContactless'
import { AutosBadgeFinancing } from '@/components/srp/listing-card/autos-badges/AutosBadgeFinancing'
import { AutosBadgesContainer } from '@/components/srp/listing-card/autos-badges/styled'

export type AutosBadgesProps = {
  testId?: string
  children?: React.ReactNode
  horizontalOverflow?: boolean
  hasDescription?: boolean
}

const AutosBadges = ({
  testId = 'listing-autos-badges',
  horizontalOverflow = false,
  children,
  hasDescription = false,
}: AutosBadgesProps) => {
  if (!children) return null
  return (
    <AutosBadgesContainer
      data-testid={testId}
      $horizontalOverflow={horizontalOverflow}
      hasDescription={hasDescription}
    >
      {children}
    </AutosBadgesContainer>
  )
}

AutosBadges.CarFax = AutosBadgeCarFax
AutosBadges.CertifiedPreOwned = AutosBadgeCertifiedPreOwner
AutosBadges.Financing = AutosBadgeFinancing
AutosBadges.Contactless = AutosBadgeContactless

export { AutosBadges }
